export enum BasketDrawerTestIds {
  'BASKET_DRAWER_FOOTER' = 'BASKET_DRAWER_FOOTER',
}
